import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { Observable } from 'rxjs';

import { FolderService } from '../../../../Monitor/Core/services/folder.service';
import { Folder } from '../../../../Monitor/Shared/models/folder.model';
import { AutocompleteComponent } from '../../../Forms/components/Autocomplete/autocomplete.component';
import { ChipModel } from '../../../Forms/models/chip.model';

@Component({
    selector: 'agpr-folders-picker',
    templateUrl: './folders-picker.component.html',
    styleUrls: ['./folders-picker.component.scss'],
    standalone: false
})
export class FoldersPickerComponent implements OnInit, OnChanges {
    @Input() folders: Folder[] = [];

    @Output() addFolder = new EventEmitter<Folder>();
    @Output() removeFolder = new EventEmitter<Folder>();

    @ViewChild('autocomplete') autocomplete: AutocompleteComponent;

    folderChips: ChipModel[] = [];
    selectedFolder: Folder;
    folderList$: Observable<Folder[]>;

    constructor(private folderService: FolderService) {}

    ngOnInit(): void {
        this.folderList$ = this.folderService.all$;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.folders) {
            this.folderChips = (this.folders || []).map(f => f.toChipModel());
        }
    }

    folderSelected(folder: Folder): void {
        this.addFolder.emit(folder);
        this.autocomplete.clearInput();
    }

    folderRemoved(index: number): void {
        this.removeFolder.emit(this.folders[index]);
    }
}
